import React, { useState } from "react";
import heroImg1 from "../../assets/image/Hero2.jpg";
import heronumber from "../../assets/image/Hero4.jpg";
import heroImg3 from "../../assets/image/Hero3.jpg";
import Cards from "./Cards";
import About from "../../Pages/About/About";
import Services from "../../Pages/Services/Service";
import Testimonials from "./Testimonials";
import Faq from "../../Pages/Faq/Faq";
import Footer from "../../Footer/Footer";
import "../../index.css"

function HomeCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const slides = [
    {
      img: heroImg1,
      title: "Expert AC Repair Services at Your Doorstep",
      description: "Experience quick, reliable, and professional air conditioning repair services—right when you need them. Trusted technicians, quality service, and 100% satisfaction guaranteed.",
    },
    {
      img: heronumber,
      title: " Friendly & Trustworthy: Big ACs, Bigger Savings!",
      description:
        "From VRS to heavy-duty ACs—we sell, install, and service it all at affordable prices and lightning-fast speed.",
    },
    {
      img: heroImg3,
      title: "Commercial & VRS AC Sales | Affordable Pricing & Quick Service",
      description:
        "Get high-performance AC systems at unbeatable prices—plus expert installation and same-day service you can count on.",
    },
  ];
  return (
    <>
      <div
        id="carouselHome"
        className="carousel slide container-fluid px-md-0 carousel-fade"
        data-bs-ride="carousel"
        
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselHome"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselHome"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselHome"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>

        <div className="carousel-inner" style={{ aspectRatio: 16 / 6 }}>
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              data-bs-interval="3000"
            >
              <img
                src={slide.img}
                className="d-block w-100"
                alt={`Slide ${index + 1}`}
              />
              {/* Overlay */}
              <div className="overlay"></div>
              {/* Caption */}
              <div className="carousel-caption custom-caption">
                <h1 className="display-5 fw-bold">{slide.title}</h1>
                <h3 className="fs-4 text">{slide.description}</h3>
              </div>
            </div>
          ))}
        </div>      
      </div>
    </>
  );
}

export default HomeCarousel;
